<pk-web-loader [show]="loading"></pk-web-loader>
@if (!loading) {
	<section class="container-fluid section-2">
		<div class="row maxwidth-1080 mx-auto d-flex justify-content-center">
			<div class="col col-md-8" id="estimatorMainDiv" [ngClass]="{ 'col-lg-6': !showResults, 'col-lg': showResults }">
				<div class="card drop-shadow">
					<div class="card-body">
						@if (formGroup) {
							<form [formGroup]="formGroup">
								<div class="row">
									<div class="col-12 col-lg">
										<div class="row">
											<div class="col">
												<h2>Utility Cost Calculator</h2>
												<p>
													Tell us a bit about your energy bills, and we'll estimate your projected energy costs along with potential savings
													opportunities.
												</p>
											</div>
										</div>
										<div class="row">
											<div class="col mb-4">
												<pk-web-form-dropdown
													label="Where are you located?"
													formControlName="state"
													[options]="states"
													textKey="stateLong"
													nullOption="Please Select"
													[nullOptionSelectable]="false"
													[isRequired]="true"
													[isInvalid]="!!err.state"></pk-web-form-dropdown>
												@if (err.state?.required) {
													<p class="font-size-075 bold-text red-text">Please choose a state.</p>
												}
											</div>
										</div>
										<div class="row">
											<div class="col mb-4">
												<label for="commodity" class="form-label d-block">Are you interested in</label>
												<div class="btn-group d-flex" role="group" aria-label="Commodity interested in">
													<input
														type="radio"
														class="btn-check"
														formControlName="serviceTypeId"
														id="electricity"
														autocomplete="off"
														[value]="CONSTANTS.serviceTypes.electricity.serviceTypeId" />
													<label class="btn btn-info w-100" for="electricity">
														<img src="https://assets.powerkiosk.com/web/images/icon-electricity-sm.svg" alt="Electricity" />
														Electricity
													</label>
													<input
														type="radio"
														class="btn-check"
														formControlName="serviceTypeId"
														id="naturalGas"
														autocomplete="off"
														[value]="CONSTANTS.serviceTypes.naturalGas.serviceTypeId" />
													<label class="btn btn-info w-100" for="naturalGas">
														<img src="https://assets.powerkiosk.com/web/images/icon-natural-gas-sm.svg" alt="Natural Gas" />
														Natural Gas
													</label>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col">
												<label for="haveSupplier" class="form-label">Are you currently with a third-party supplier?</label>
											</div>
										</div>
										<div class="row mt-1 mb-4">
											@for (option of haveSupplierOptions; track option) {
												<div class="col">
													<div class="form-check">
														<input class="form-check-input" type="radio" formControlName="haveSupplier" id="{{ option.value }}" [value]="option" />
														<label class="form-check-label" for="{{ option.value }}">
															{{ option.text }}
														</label>
													</div>
												</div>
											}
										</div>
										<div class="row">
											<div class="col mb-4">
												<label for="lastEnergyBill" class="form-label required" [class.invalid]="err.monthlySpend"
													>How much was your last energy bill? (Supply Charge only)</label
												>
												<div class="input-group mb-3">
													<span class="input-group-text left-side">
														<fa-icon [icon]="['fas', 'dollar-sign']"></fa-icon>
													</span>
													<input type="number" class="form-control" formControlName="monthlySpend" aria-label="How much was your last energy bill?" />
												</div>
												@if (err.monthlySpend?.required || err.monthlySpend?.min) {
													<p class="font-size-075 bold-text red-text">Please enter in how your last energy bill was.</p>
												}
											</div>
										</div>
										<div class="row d-flex">
											<div class="col mb-4">
												<button type="button" class="btn btn-primary btn-lg w-100" id="calcBtn" (click)="submit()" [disabled]="submitDisabled">
													{{ submitText }}
												</button>
											</div>
										</div>
									</div>
									@if (showResults) {
										<div class="col-12 col-lg" id="estimatorResultsDiv">
											<div class="row">
												<div class="col">
													<div class="card estimator-results py-3">
														<div class="card-body">
															<pk-web-loader [show]="submitDisabled" color="white"></pk-web-loader>
															@if (!submitDisabled && costEstimatorResults) {
																<div class="row">
																	<div class="col text-center pb-2">
																		<h3 class="white-text">
																			Looking at {{ CONSTANTS.serviceTypes[form.serviceTypeId.value] }} in {{ form.state.value.stateLong }}
																		</h3>
																	</div>
																</div>
																<div class="row">
																	<div class="col estimated-savings-div pt-2">
																		<p class="est-savings-title">Projected Annual Spend:</p>
																		<p class="est-savings-num">{{ costEstimatorResults.projectedAnnualSpend | currency }}</p>
																		<hr class="white-divider my-4" />
																	</div>
																</div>
																@if (costEstimatorResults.saveUpToPercent > 0) {
																	<div class="row">
																		<div class="col position-relative">
																			<div class="savings-percentile">
																				<p class="savings-msg">you could<br />save up to</p>
																				<p class="savings-num">{{ costEstimatorResults.saveUpToPercent }}<sup>%</sup></p>
																			</div>
																			<pk-web-cost-estimator-chart
																				[saveUpToPercent]="costEstimatorResults.saveUpToPercent"></pk-web-cost-estimator-chart>
																		</div>
																	</div>
																}
																@if (costEstimatorResults.saveUpToPercent > 0) {
																	<div class="row">
																		<div class="col estimated-savings-div pt-2">
																			<p class="est-savings-title">Projected Estimated Savings:</p>
																			<p class="est-savings-num">{{ costEstimatorResults.projectedEstimatedSavings | currency }}</p>
																			<hr class="white-divider my-4" />
																		</div>
																	</div>
																}
																<div class="row">
																	<div class="col text-center">
																		@if (isDeregulated) {
																			<p class="white-text font-size-1 semibold-text">Are you interested in lowering your energy costs?</p>
																		}
																		@if (!isDeregulated) {
																			<p class="white-text font-size-1 semibold-text">
																				You are receiving energy in a regulated market, but there could be potential savings in the future.
																			</p>
																		}
																		@if (isDeregulated && costEstimatorResults.projectedEstimatedSavings === null) {
																			<p class="white-text font-size-1 semibold-text">
																				We need more information about your account to determine potential savings in your market.
																			</p>
																		}
																		<p>
																			<a routerLink="/schedule-discovery-call" class="btn btn-secondary">Schedule Discovery Call</a>
																		</p>
																		<p class="mb-0">
																			<a
																				href="javascript:void(0);"
																				type="button"
																				class="light-link medium-text font-size-085"
																				(click)="openNewsletterModal()"
																				>Need more time? Stay in the loop with our newsletter!</a
																			>
																		</p>
																	</div>
																</div>
															}
														</div>
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							</form>
						}
					</div>
				</div>
			</div>
		</div>
	</section>
}
